import { PLY_CHANNEL_NAME, BROADCAST_CHANNEL } from '@/broadcastChannel/broadcast-channel.const';
import EncryptService from '@/utils/encrypt-service';

/* PRIVATE */
const _encrypt = (payload = {}) => {
	try {
		return EncryptService.encrypt(payload);
	} catch (e) {
		console.error('BroadcastChannelService._encrypt()', e);
	}
};
const _decrypt = (encryptedStr = '') => {
	try {
		return EncryptService.decrypt(encryptedStr);
	} catch (e) {
		console.error('BroadcastChannelService._decrypt()', e);
	}
};
/* PUBLIC */

export const bc = new BroadcastChannel(PLY_CHANNEL_NAME);

const encrypt = _encrypt;
const decrypt = _decrypt;
const postBroadcastMessage = (eventName, params = {}) => {
	if (eventName) {
		const encryptedData = encrypt({ eventName, params, PLY_ENV: process.env.VUE_APP_PLY_ENV });
		if (encryptedData) {
			bc.postMessage(encryptedData);
		}
	}
};

function calculateLogoutReturnTo(router, fromBroadcastChannel) {
	// redirect to login for login purposes but keep the location we were just at so we know how to return back
	const currentFullPath = router.currentRoute.fullPath;

	let returnTo = currentFullPath;
	if (!currentFullPath.includes(BROADCAST_CHANNEL) && fromBroadcastChannel) {
		const currentPath = router.currentRoute.fullPath;
		const processedQueryString = new URLSearchParams(router.currentRoute.query);
		processedQueryString.append(BROADCAST_CHANNEL, !!fromBroadcastChannel);
		returnTo = `${currentPath}?${processedQueryString.toString()}`;
	}
	return returnTo;
}

const BroadcastChannelService = {
	decrypt,
	postBroadcastMessage,
	calculateLogoutReturnTo,
};

export default BroadcastChannelService;
